export class AddressRequest {
    lat: number;
    lng: number;
}